import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20product%20display%20table%20with%20curated%20fashion%20items%20including%20premium%20sneakers%20bags%20and%20accessories%20arranged%20on%20warm%20cream%20surface%2C%20soft%20golden%20hour%20natural%20light%20streaming%20through%20window%2C%20elegant%20editorial%20product%20photography%2C%20warm%20terracotta%20and%20beige%20tones%2C%20sophisticated%20retail%20aesthetic%2C%20clean%20organized%20composition%2C%20luxury%20shopping%20atmosphere&width=1600&height=800&seq=cta-product-display-02&orientation=landscape"
          alt="Ready to discover better products with Basetao Spreadsheet"
          className="w-full h-full object-cover"
          title="Basetao Spreadsheet - Ready to Discover Better Products"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-5">
          Ready to Discover Better Products?
        </h2>
        <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-10 max-w-xl mx-auto">
          Explore our complete Basetao Spreadsheet resource. Find products faster, compare smarter, and shop with confidence using our expert guides and curated databases.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-lg bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap inline-flex items-center gap-2"
          >
            <span>Visit Main Platform</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </div>
          </a>
          <Link
            to="/shopping-guide"
            className="px-8 py-4 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
          >
            Browse All Guides
          </Link>
        </div>
      </div>
    </section>
  );
}